<template>
    <div class="houseDeposit">
        <bv-top></bv-top>
        <van-cell-group>
            <van-field
                    v-model.trim="regionName"
                    required
                    clearable
                    label="所属小区"
                    placeholder="请输入小区名称"
            >
            </van-field>
            <!--小区名称下拉列表-->
            <van-cell-group id="regionSearch" class="regionList" v-if="searchShow">
                <van-cell
                        v-for="item in RegionList"
                        :key="item.regionNo"
                        :title="item.regionName"
                        @click="regionListClick(item)"
                        style=" float: right"
                />
            </van-cell-group>
            <!--选择房屋-->
            <van-field
                    readonly
                    required
                    clickable
                    label="选择房屋"
                    :value="houseValue"
                    placeholder="请选择房屋"
                    @click="houseInputClick"
            />
            <!--房屋选择器-->
            <van-popup id="searchHouse" v-model="showPicker" round position="bottom">
                <van-picker
                        show-toolbar
                        :columns="houseDate"
                        @cancel="showPicker = false"
                        @confirm="onConfirmHouse"
                        @change="housePickerChange"
                />
            </van-popup>
        </van-cell-group>
        <van-row type="flex" justify="center">
            <van-col span="22">
                <van-button type="primary" size="large" @click="userHouses" class="btn">交存申请</van-button>
            </van-col>
        </van-row>
      <van-row type="flex" justify="center">
        <van-col span="22">
          <van-button type="primary" size="large" @click="userHouses" class="btn">交存约定书查询</van-button>
        </van-col>
      </van-row>

    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import { regions, depositApply, fetchBldCellHouses } from '@/api/maintainFund/maintainFund'

    export default {
        name: "houseDeposit",
        data() {
            return {
                regionName: '',
                regionSearchName:'',
                regionNo: '',
                onLineDeposit: '',
                region: {},
                regionList: [],
                showPicker: false,
                ownerName: '',
                ownerCertNo: '',
                isowner: 'Y',
                searchShow: false,
                houseDate:[],
                houseValue: "",
                defaultIndex: [0, 0, 0],
            }
        },
        mounted() {
            document.addEventListener('click', this.houseListClose)
        },
        watch: {
            regionName() {
                this.fetchData();
            }
        },
        components: {
            BvTop: Top,
        },
        methods: {
            async  fetchData() {
                this.houseValue = "";
                let param = {
                    regionName: this.regionName
                }
                if (this.regionSearchName != this.regionName){
                    regions(param).then(response => {
                        this.searchShow = false;
                        this.RegionList = response.data;
                        this.searchShow = true;
                    }).catch(() => {
                        this.searchShow = false;
                    });
                }
            },
            //小区下拉列表点击
            regionListClick: function (region) {
                this.region = region;
                this.divisionCode = region.divisionCode;
                this.regionName = region.regionName;
                this.regionSearchName = region.regionName;
                this.regionNo = region.regionNo;
                this.searchShow = false;
                this.onLineDeposit = region.onLineDeposit
            },

            //房屋选择器变化函数
            housePickerChange(picker, values, index) {
                let that_ = this;
                if (values[0]) {
                    that_.bld = values[0].key;
                }
                if (values[1]) {
                    that_.cell = values[1].key;
                }
                if (values[2]) {
                    that_.house = values[2].key;
                }
                let param = {
                    regionNo: this.regionNo
                };
                if (index === 0) {
                    that_.loading = true;
                    param.bldNo = that_.bld;
                    fetchBldCellHouses(param).then(response => {
                        const data = response.data;

                        this.$set(this.houseDate, 1, {
                            values: data[0]
                        });
                        this.$set(this.houseDate, 2, {
                            values: data[1]
                        });

                        if (data[0].length > 0 && data[1].length > 0) {
                            this.currentHouse = values[0].text + '-' + data[0][0].text + '-' + data[1][0].text;
                        } else {
                            this.currentHouse = '';
                        }

                        that_.loading = false;
                    })
                }
                if (index === 1) {
                    that_.loading = true;
                    param.bldNo = that_.bld;
                    param.cellNo = that_.cell;
                    fetchBldCellHouses(param).then(response => {
                        const data = response.data;
                        this.$set(this.houseDate, 2, {
                            values: data[0]
                        });
                        if (data[0].length > 0) {
                            this.currentHouse = values[0].text + '-' + values[1].text + '-' + data[0][0].text;
                        } else {
                            this.currentHouse = '';
                        }

                        that_.loading = false
                    })
                }
                if (index === 2) {
                    this.address = values[2].extra;
                    this.currentHouse = values[0].text + '-' + values[1].text + '-' + values[2].text;
                    this.defaultCell = values[1].text;
                    this.defaultHouse = values[2].text;
                }
            },

            //点击空白处关闭列表
            houseListClose: function () {
              this.searchShow = false
            },

            //选择房屋
            houseInputClick() {
                if (this.regionNo) {
                    let param = {
                        regionNo: this.regionNo
                    };
                    fetchBldCellHouses(param).then(response => {
                        const data = response.data;
                        this.$set(this.houseDate, 0, {
                            values: data[0]
                        });
                        this.$set(this.houseDate, 1, {
                            values: data[1]
                        });
                        this.$set(this.houseDate, 2, {
                            values: data[2]
                        });
                        this.showPicker = true
                        this.houseDate.$forceUpdate()
                        if (this.houseValue === '') {
                            //获取后台返回默认值，往选择楼栋页面位置展示
                            this.houseValue = data[0][0].text + '-' + data[1][0].text + '-' + data[2][0].text
                        } else {
                            //获取用户选择获得值，往选择楼栋页面位置展示
                            this.$set(this.houseDate, 1, {
                                values: this.defaultCell
                            });
                            this.$set(this.houseDate, 2, {
                                values: this.defaultHouse
                            });
                        }
                    }).catch(
                        this.houseDate = []
                    )
                } else {
                    this.$dialog.alert({
                        message: '请先选择小区'
                    });
                }
            },

            //选择房屋回显赋值
            onConfirmHouse(values) {
                if (values[0] && values[1] && values[2]) {
                    this.cellNo = values[1].key
                    this.houseNo = values[2].key
                    this.houseValue = values[0].text + '-' + values[1].text + '-' + values[2].text;
                    this.showPicker = false;
                } else {
                    this.$toast.fail("请选择绑定房屋...");
                    return;
                }
            },

            //交存申请
            userHouses() {
                let param = {
                    divisionCode: this.divisionCode,
                    regionNo: this.regionNo,
                    bldNo: this.bldNo,
                    cellNo: this.cellNo,
                    houseNo: this.houseNo,
                    ownerName: this.ownerName,
                    ownerCertNo: this.ownerCertNo,
                    isowner: this.isowner
                };
                if (this.onLineDeposit == 'Y'){
                  if (this.houseNo == null || this.houseNo == null) {
                    this.$dialog.alert({
                      message: "请先正确选择房屋"
                    }).catch()
                  } else {
                    depositApply(param).then(res => {
                      if (res.data.retCode === '0000') {
                        this.$dialog.alert({
                          message: res.data.retDesc
                        }).then(() => {
                          this.$router.push({
                            path: '/maintainFund/depositInfo',
                            query: {
                              label: '交存申请',
                              payChannels: res.data.payChannels,
                              houseDepMobiles: res.data.houseDepMobiles
                            }
                          })
                        });
                      } else if (res.data.retCode === '0001') {
                        //代交
                        this.$dialog.alert({
                          message: res.data.retDesc,
                          showCancelButton: true
                        }).then(() => {
                          this.$router.push({
                            path: '/maintainFund/ownerConfirm',
                            query: {
                              houseNo: res.data.houseNo,
                              subAccount: res.data.subAccount
                            }
                          })
                        }).catch(() => {
                          console.info("用户取消了交存...");
                        });
                      }
                    })
                  }
                } else {
                  this.$dialog.alert({
                    message: "当前小区暂未开放在线交存功能"
                  })
                }
            }
        }
    }
</script>

<style lang='scss' scoped>
    .houseDeposit {
        height: 100vh;
        background: #f2f2f2;

        .btn {
            margin-top: 5%;
            border-radius: 5px;
            background-color: #2acba2 !important;
            border: 1px solid #2acba2 !important;
        }

        .footFont {
            font-weight: normal;
            font-size: 14px;
            color: #999;
        }
    }

    .regionList {
        z-index: 100;
        position: absolute;
        width: 100%;
        margin-left: 25%;
        display: inline !important;
        list-style: none;
        overflow-y: scroll;
        line-height: 2;
        border-radius: 6px;
        background: white;

    }
</style>
